import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Outlet, useLocation } from "react-router-dom";
// import "./Configuration.css";
import ConfigurationHeader from "../../components/configuration/ConfigurationHeader";
import { screenConfig } from "../../config/screenConfig";
import MemberType from "./memberType/MemberType";
import AdminUserCreation from "../../components/configuration/AdminUserCreation";
import MemberCode from "./memberCode/MemberCode";
import AdminUserComponent from "../../components/configuration/AdminUserComponent";
import {
  changeAdminUserScreen,
  // screenChange
} from "../../store/screenSlice";
import MemberTag from "./memberTag/MemberTag";
import MemberSection from "./memberSection/MemberSection";
import FirmManagement from "./FirmManagement/FirmManagement";
import Location from "./Location/location";
import Cost from "./Cost/cost";
import HelpVideos from "./HelpVideos/HelpVideos";
const Configuration: React.FC = () => {
  const dispatch = useDispatch();
  // dispatch(screenChange("Settings"));
  const currentConfigurationMenu = useSelector(
    (state: RootState) => state.screen.currentConfigurationMenu
  );

  useEffect(() => {
    dispatch(changeAdminUserScreen(screenConfig.adminUserListScreen));
  }, []);

  const renderConfigurationMenu = () => {
    if (currentConfigurationMenu == screenConfig.adminUserConfiguration) {
      return <AdminUserComponent />;
    } else if (
      currentConfigurationMenu == screenConfig.adminUserCreationConfiguration
    ) {
      return <AdminUserCreation />;
    } else if (
      currentConfigurationMenu == screenConfig.memberTypeConfiguration
    ) {
      return <MemberType />;
    } else if (
      currentConfigurationMenu == screenConfig.memberCodeConfiguration
    ) {
      return <MemberCode />;
    } else if (
      currentConfigurationMenu == screenConfig.memberTagConfiguration
    ) {
      return <MemberTag />;
    } else if (
      currentConfigurationMenu == screenConfig.memberSectionConfiguration
    ) {
      return <MemberSection />;
    } else if (
      currentConfigurationMenu == screenConfig.FirmManagementConfiguration
    ) {
      return <FirmManagement />;
    } else if (
      currentConfigurationMenu == screenConfig.LocationConfiguration
    ) {
      return <Location />;
    }else if (
      currentConfigurationMenu == screenConfig.CostConfiguration
    ) {
      return <Cost />;
    }else if (
      currentConfigurationMenu == screenConfig.HelpVideosConfiguration
    ) {
      return <HelpVideos />;
    }
  };

  return (
    <div className="dashboard-wrapper" style={{ display: 'inline-block' }}>
      {/* <div className="p-4 w-100 h-100 border border-secondary"> */}
      <ConfigurationHeader />
      {renderConfigurationMenu()}
      {/* </div> */}
    </div>
  );
};

export default Configuration;
